import { ArrowUpRight } from "lucide-react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo-white-trans.avif";
import "./Footer.css";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const access = [
    {
      title: "The Shift",
      id: "shift",
    },
    {
      title: "Artificial Intelligence",
      id: "ai",
    },
    {
      title: "NHI",
      id: "nhi",
    },
    {
      title: "Principles",
      id: "principles",
    },
  ];

  useEffect(() => {
    if (location.pathname !== "/" || !location.hash) return;

    const id = location.hash.replace("#", "");

    const timeout = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
      });
    }, 100);

    return () => clearTimeout(timeout);
  }, [location.pathname, location.hash]);

  const goTo = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`, {
        state: {
          skipIntro: true,
        },
      });

      return;
    }

    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <img src={logo} className="footer-logo" alt="Symphonia" />

          <p>Natural Human Intelligence for the age beyond artificial.</p>
        </div>

        <div className="footer__documents">
          <span>Quick Access</span>

          {access.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => goTo(item.id)}
              className="footer__access-link"
            >
              {item.title}
              <ArrowUpRight size={14} />
            </button>
          ))}
        </div>

        <div className="footer__documents">
          <span>Source documents</span>

          <a
            href="/docs/symphonia-brand-blueprint.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Brand Blueprint
            <ArrowUpRight size={14} />
          </a>

          <a
            href="/docs/symphonia-shift-nhi.pdf"
            target="_blank"
            rel="noreferrer"
          >
            The Shift with NHI
            <ArrowUpRight size={14} />
          </a>

          <a
            href="/docs/symphonia-extended-nhi.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Extended Framework
            <ArrowUpRight size={14} />
          </a>
        </div>
      </div>

      <div className="footer__meta px-5">
        <span>Humanity conducts</span>
        <small>© {new Date().getFullYear()} Symphonia</small>
      </div>
    </footer>
  );
}
